module.exports = __webpack_public_path__ + "media/images/about/h_4-17329e5d99f2a39622816533fc74d740.png";